<mwe-empty-state
  staticImage="add-products.svg"
  [headlineText]="titleToUse()"
  [messageKeys]="[noAddressGroupsText()]"
  ctaLabel="products-add.title"
  (onCtaClick)="navigateToProductSearch()"
/>
